import { LogoColorVariant, LogoWithName } from '../../LogoWithName';
import { ContentBoxWrapper, MainContentBox } from '../Box/Box.style';
import { ColWithBackgroundImageStyled } from './ColWithBackgroundImage.style';

interface ColWithBackgroundImageProps {
  img: string;
  logoColorVariant?: LogoColorVariant;
}

export const ColWithBackgroundImage: React.FC<ColWithBackgroundImageProps> = (props) => {
  return (
    <ColWithBackgroundImageStyled img={props.img}>
      <ContentBoxWrapper offsetVariant={80}>
        {props.logoColorVariant && (
          <MainContentBox>
            <LogoWithName colorVariant={props.logoColorVariant} />
          </MainContentBox>
        )}
      </ContentBoxWrapper>
    </ColWithBackgroundImageStyled>
  );
};
